export default __webpack_public_path__ + "static/media/galvanic-zinc-plating-icon-dark.ea29fd3c.svg";